export default {
      id: "resetFilters-usage",
      viewBox: "0 0 21 18",
      url: __webpack_public_path__ + "sprite.1789552432127.svg#resetFilters-usage",
      toString: function () {
        return this.url;
      }
    }